import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//scroll behavior -- see if you can get this outta here -- there's too much
//in the way of the router
const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    return savedPosition
  } else {
    const position = {}
    // new navigation.
    // scroll to anchor by returning the selector
    if (to.hash) {
      position.selector = to.hash

      // specify offset of the element
      if (to.hash === '#anchor2') {
        position.offset = { y: 100 }
      }
    }
    // check if any matched route config has meta that requires scrolling to top
    if (to.matched.some(m => m.meta.scrollToTop)) {
      // cords will be used if no selector is provided,
      // or if the selector didn't match any element.
      position.x = 0
      position.y = 0
    }
    // if the returned position is falsy or an empty object,
    // will retain current scroll position.
    return position
  }
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
    },

    {
      path: '/history',
      name: 'history',
      component: () => import(/* webpackChunkName: "history" */ './views/History.vue'),
    },

    {
      path: '/board',
      name: 'board',
      component: () => import(/* webpackChunkName: "board" */ './views/Board.vue'),
    },

    {
      path: '/activities',
      name: 'activities',
      component: () => import(/* webpackChunkName: "activities" */ './views/Activities.vue'),
    },

    {
      path: '/campgrounds',
      name: 'campgrounds',
      component: () => import(/* webpackChunkName: "campgrounds" */ './views/Campgrounds.vue'),
    },

    {
      path: '/rules/park',
      name: 'park_rules',
      component: () => import(/* webpackChunkName: "park_rules" */ './views/ParkRules.vue'),
    },

    {
      path: '/rules/camping',
      name: 'camping_rules',
      component: () => import(/* webpackChunkName: "camping_rules" */ './views/CampingRules.vue'),
    },

    {
      path: '/rules/fishing',
      name: 'fishing_rules',
      component: () => import(/* webpackChunkName: "fishing_rules" */ './views/FishingRules.vue'),
    },

    {
      path: '/rules/hunting',
      name: 'hunting_rules',
      component: () => import(/* webpackChunkName: "hunting_rules" */ './views/HuntingRules.vue'),
    },

  ]
})
